import { useState } from "react";
import { VoiceModel } from "@/actions/db/get-models";
import useModelsData from "@/components/pages/home/hooks/use-models-data";
import { useScroller } from "@/hooks/use-scroller";

export type BlendingCompatibilityCategory = {
  name: string;
  isVoiceMatching: (voice: VoiceModel) => boolean;
};

export const useBlendingVoiceSelect = (otherVoice: VoiceModel | undefined) => {
  const compatibilityCategories: BlendingCompatibilityCategory[] = otherVoice
    ? [
        {
          name: "Compatible",
          isVoiceMatching: (voice) =>
            !!(voice.sr && voice.sr === otherVoice?.sr),
        },
        {
          name: "Partially Compatible",
          isVoiceMatching: (voice) =>
            !!(voice.sr && voice.sr !== otherVoice?.sr),
        },
        {
          name: "Compatibility Unknown",
          isVoiceMatching: (voice) => !voice.sr,
        },
      ]
    : [];

  const [selectedCompatibilityCategory, setSelectedCompatibilityCategory] =
    useState(otherVoice ? compatibilityCategories[0] : undefined);

  const { scrollY, scrollUpdate } = useScroller();

  const modelsData = useModelsData();

  const filteredVoiceList = modelsData.filteredVoiceList.filter((voice) => {
    if (!otherVoice) {
      return true;
    }

    return (
      voice.id != otherVoice.id &&
      selectedCompatibilityCategory?.isVoiceMatching(voice)
    );
  });

  const isCompatible = () => {
    if (!otherVoice || !compatibilityCategories) {
      return true;
    }

    return (
      compatibilityCategories[0].name === selectedCompatibilityCategory?.name
    );
  };

  const isCategorySelected = (category: BlendingCompatibilityCategory) => {
    return category.name === selectedCompatibilityCategory?.name;
  };

  return {
    ...modelsData,
    filteredVoiceList,
    scrollY,
    scrollUpdate,
    compatibilityCategories,
    setSelectedCompatibilityCategory,
    isCompatible,
    isCategorySelected,
  };
};
